// CLARTEXT · UI-V2 · Firmenname-Dialog (übernommen aus EinmalkaufPanel.jsx).
//
// STRICT SCOPE: verhaltensidentisch zum bestehenden Dialog in
// components/landing/EinmalkaufPanel.jsx (V5I-B / V5G §7):
//   - null = noch keine Wahl
//   - "ja" → Textfeld erscheint; companyName wird gepflegt
//   - "nein" → companyName wird zurückgesetzt
// Keine neue Businesslogik, keine neue Validierung — nur eine wiederver-
// wendbare Extraktion. EinmalkaufPanel.jsx wird in UI-V2 NICHT verändert.
//
// Diese Komponente bringt eigene, isolierte Inline-Styles mit, damit sie
// visuell zum hellen Design der Abschlussseite v2 passt (nicht zum dunklen
// Panel der Landing). Die Interaktions- und Fehlersemantik ist 1:1 gleich.
import { useEffect, useState } from "react";

// Kleiner Wahl-Button (Ja/Nein). Neutraler, heller Stil passend zur v2-Seite.
function ChoiceButton({ active, onClick, testId, children }) {
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      className="p-btn"
      style={{
        width: "auto",
        height: 42,
        marginTop: 0,
        padding: "0 22px",
        borderRadius: 999,
        fontFamily: '"Manrope", sans-serif',
        fontWeight: 700,
        fontSize: "0.95rem",
        cursor: "pointer",
        border: active ? "1px solid #1a3f6f" : "1px solid #cbd5e1",
        background: active ? "#1a3f6f" : "#fff",
        color: active ? "#fff" : "#1a3f6f",
        transition: "background-color 0.2s, border-color 0.2s",
      }}
    >
      {children}
    </button>
  );
}

export default function FirmennameDialog({
  choice,
  onChoice,
  companyName,
  onCompanyNameChange,
  testId = "firmenname-dialog",
}) {
  const [focused, setFocused] = useState(false);

  // Nach „Nein" wird der bereits eingegebene Name zurückgesetzt (identisch
  // zum bestehenden EinmalkaufPanel-Verhalten).
  useEffect(() => {
    if (choice === "nein" && companyName !== "") {
      onCompanyNameChange("");
    }
    setFocused(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [choice]);

  return (
    <div data-testid={testId} style={{ marginTop: 18 }}>
      <p
        style={{
          margin: "0 0 10px",
          fontSize: "0.98rem",
          color: "#1a3f6f",
          fontWeight: 600,
        }}
      >
        Möchten Sie Ihren Firmennamen auf der Arbeitsschutzmappe ausgeben?
      </p>
      <div style={{ display: "flex", gap: 10 }}>
        <ChoiceButton
          active={choice === "ja"}
          onClick={() => onChoice("ja")}
          testId="firmenname-ja-button"
        >
          Ja
        </ChoiceButton>
        <ChoiceButton
          active={choice === "nein"}
          onClick={() => onChoice("nein")}
          testId="firmenname-nein-button"
        >
          Nein
        </ChoiceButton>
      </div>

      {choice === "ja" && (
        <div style={{ marginTop: 12 }}>
          <label
            htmlFor="abschluss-v2-company-input"
            style={{
              display: "block",
              fontSize: "0.9rem",
              color: "#1e293b",
              fontWeight: 600,
              marginBottom: 6,
            }}
          >
            Firmenname (erscheint auf dem PDF)
          </label>
          <input
            id="abschluss-v2-company-input"
            data-testid="abschluss-v2-company-input"
            type="text"
            value={companyName}
            onChange={(e) => onCompanyNameChange(e.target.value)}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            placeholder="z. B. Mustermann GmbH"
            maxLength={120}
            style={{
              width: "100%",
              boxSizing: "border-box",
              padding: "11px 13px",
              borderRadius: 10,
              border: focused ? "1.5px solid #1a3f6f" : "1.5px solid #94a3b8",
              background: "#fff",
              color: "#1a3f6f",
              fontSize: 15,
              fontFamily: '"Manrope", sans-serif',
              outline: "none",
              boxShadow: focused ? "0 0 0 3px rgba(26,63,111,0.18)" : "none",
              transition: "border-color 0.15s, box-shadow 0.15s",
            }}
          />
        </div>
      )}
    </div>
  );
}
